// Id copiável (WEB-133): o id em mono com o botão de copiar colado nele. Nas gavetas do
// backoffice o id é o que o operador leva pra outra tela ou pro suporte, então a cópia
// mora ao lado dele, não num botão solto no fim da gaveta.

import { useEffect, useState } from 'react';
import { cn } from '../../lib/cn.ts';
import { Check, Copy } from '../icons/index.tsx';
import { Button } from '../ui/button.tsx';

const COPIED_MS = 2000;

export function CopyId({
  value,
  label = 'Copiar id',
  className,
}: {
  value: string;
  /** Nome acessível do botão: duas cópias na mesma gaveta pedem nomes diferentes. */
  label?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  // O "copiado" se apaga sozinho, e o timer morre junto com o componente.
  useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setCopied(false);
    }, COPIED_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);

  return (
    <span className={cn('inline-flex min-w-0 items-center gap-0.5', className)}>
      <span className="data-value min-w-0 break-all">{value}</span>
      <Button
        type="button"
        variant="ghost"
        size="icon-xs"
        aria-label={label}
        title={label}
        className="shrink-0 text-muted-foreground hover:text-foreground"
        onClick={() => {
          void navigator.clipboard?.writeText(value).then(() => {
            setCopied(true);
          });
        }}
      >
        {copied ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />}
      </Button>
    </span>
  );
}
